import { api } from '@api/api2';

export const getEventTypes = () => api.no_vers('get', 'information/get-events-types');
